(function () {
  function expandedGetter(component) {
    for (var prototype = Object.getPrototypeOf(component); prototype; prototype = Object.getPrototypeOf(prototype)) {
      var descriptor = Object.getOwnPropertyDescriptor(prototype, '_isExpanded');
      if (descriptor) return descriptor.get;
    }
  }

  // Bundly renders the contents conditionally. Adapt each instance's expansion
  // check while leaving its renderer, variant stores and shared prototype intact.
  function createIndependentSelectors(components) {
    var states;
    try {
      if (!components.length || components.some(function (component) {
        return Object.prototype.hasOwnProperty.call(component, '_isExpanded') ||
          typeof expandedGetter(component) !== 'function' ||
          typeof component.requestUpdate !== 'function' ||
          typeof component._toggleExpand !== 'function' ||
          typeof component._isExpanded !== 'boolean';
      })) return null;
      states = new Map(components.map(function (component) { return [component, true]; }));
    } catch (_) { return null; }
    var installed = [];
    try {
      components.forEach(function (component) {
        Object.defineProperty(component, '_isExpanded', {
          configurable: true,
          get: function () { return states.get(component); },
        });
        installed.push(component);
      });
      // Start every section open once; later updates preserve the buyer's choices.
      installed.forEach(function (component) { component.requestUpdate(); });
    } catch (_) {
      installed.forEach(function (component) { delete component._isExpanded; });
      return null;
    }
    function set(component, expanded) {
      if (!states.has(component)) return false;
      if (states.get(component) !== expanded) {
        states.set(component, expanded);
        component.requestUpdate();
      }
      return true;
    }
    return {
      toggle: function (component) { return set(component, !states.get(component)); },
      open: function (component) { return set(component, true); },
      completeSelection: function (component, incomplete) {
        var index = components.indexOf(component);
        if (index < 0 || incomplete.indexOf(component) !== -1) return null;
        set(component, false);
        var next = components.slice(index + 1).concat(components.slice(0, index)).find(function (candidate) {
          return incomplete.indexOf(candidate) !== -1;
        });
        if (next) set(next, true);
        return next || null;
      },
      release: function () {
        installed.forEach(function (component) { delete component._isExpanded; component.requestUpdate(); });
        states.clear();
      },
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createIndependentSelectors: createIndependentSelectors };
  if (typeof document === 'undefined') return;

  var records = new Map();
  var pending = false;
  function initialize() {
    records.forEach(function (record, root) {
      var current = Array.from(root.querySelectorAll('bundly-collection-component'));
      if (!root.isConnected || current.length !== record.components.length || current.some(function (component, index) { return component !== record.components[index]; })) {
        record.controls.release();
        root.removeEventListener('click', record.click, true);
        root.removeEventListener('bundly:afterAddVariant', record.selected);
        records.delete(root);
      }
    });
    document.querySelectorAll('.bundly__information_app_block .bundly__block').forEach(function (root) {
      if (records.has(root)) return;
      var components = Array.from(root.querySelectorAll('bundly-collection-component'));
      if (!components.length || components.some(function (component) { return !component.querySelector('.bundly__component_header'); })) return;
      var controls = createIndependentSelectors(components);
      if (!controls) return; // An app update must degrade to its native accordion.
      function click(event) {
        var header = event.target.closest('.bundly__component_header');
        if (header && controls.toggle(header.closest('bundly-collection-component'))) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        var button = event.target.closest('.bundly__slot_select');
        var slot = button && button.closest('bundly-slot');
        if (!slot) return;
        var index = slot.getAttribute('data-component-index');
        var component = components.find(function (element) { return element.getAttribute('data-component-index') === index; });
        // Keep the summary's native navigation and scroll behavior.
        if (component) controls.open(component);
      }
      function selected(event) {
        var detail = event.detail || {};
        // Initial URL/default selections must not collapse the page on entry.
        if (!detail.sourceElement || detail.sourceElement.localName === 'bundly-init') return;
        var component = components.find(function (element) {
          return element.getAttribute('data-component-index') === String(detail.componentIndex);
        });
        if (!component) return; // Fixed products have no collection accordion.
        var slots = Array.from(root.querySelectorAll('.bundly__details bundly-slot'));
        var incomplete = components.filter(function (element) {
          var index = element.getAttribute('data-component-index');
          var choices = slots.filter(function (slot) { return slot.getAttribute('data-component-index') === index; });
          return !choices.length || choices.some(function (slot) { return !slot.getAttribute('data-variant-id'); });
        });
        if (incomplete.indexOf(component) !== -1) return;
        var next = controls.completeSelection(component, incomplete);
        window.requestAnimationFrame(function () {
          if (!root.isConnected || !records.has(root)) return;
          var target = next ? next.querySelector('.bundly__component_header') : root.querySelector('.bundly__add_to_cart_button:not(:disabled)');
          if (!target) return;
          target.focus({ preventScroll: true });
          var destination = next || target;
          destination.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            block: next ? 'start' : 'nearest',
          });
        });
      }
      root.addEventListener('click', click, true);
      root.addEventListener('bundly:afterAddVariant', selected);
      records.set(root, { controls: controls, click: click, selected: selected, components: components });
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; initialize(); });
  }
  // Includes theme-editor replacement and app block rerenders. Only discovery
  // runs here; ordinary variant and option behavior remains owned by Bundly.
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('bundly:afterLoadBundle', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.customElements.whenDefined('bundly-collection-component').then(schedule);
  schedule();
})();
